"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductViewer = exports.default = void 0;
var product_viewer_component_1 = require("./product-viewer.component");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(product_viewer_component_1).default; } });
Object.defineProperty(exports, "ProductViewer", { enumerable: true, get: function () { return product_viewer_component_1.ProductViewer; } });
